<template lang="pug">
  ContentLoader(:width="300" :height="285")
    rect(x="0", y="0", rx="4", ry="4", width="100%", height="15")

    rect(x="0", y="24", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="36", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="24", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="36", rx="4", ry="4", width="48%", height="15")

    rect(x="0", y="64", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="76", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="64", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="76", rx="4", ry="4", width="48%", height="15")

    rect(x="0", y="104", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="116", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="104", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="116", rx="4", ry="4", width="48%", height="15")

    rect(x="0", y="150", rx="4", ry="4", width="100%", height="15")

    rect(x="0", y="174", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="186", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="174", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="186", rx="4", ry="4", width="48%", height="15")

    rect(x="0", y="214", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="226", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="214", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="226", rx="4", ry="4", width="48%", height="15")

    rect(x="0", y="254", rx="4", ry="4", width="20%", height="10")
    rect(x="0", y="266", rx="4", ry="4", width="48%", height="15")
    rect(x="51.5%", y="254", rx="4", ry="4", width="20%", height="10")
    rect(x="51.5%", y="266", rx="4", ry="4", width="48%", height="15")
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "VclRegForm",

  components: { ContentLoader }
};
</script>

<style lang="sass" scoped></style>
